var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2167AE",
    d: "M5 10.5C5 6.94 8.1 4 12 4s7 2.94 7 6.5a6.4 6.4 0 0 1-3.62 5.7q-.5.26-.76.8H12.5v-3.56a2 2 0 1 0-1 0V17H9.38a1.6 1.6 0 0 0-.76-.8A6.35 6.35 0 0 1 5 10.5H4a7.4 7.4 0 0 0 4.16 6.58c.22.11.34.31.34.51V20a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-2.41c0-.2.12-.4.34-.5q.5-.27.95-.58A7.4 7.4 0 0 0 20 10.5C20 6.33 16.39 3 12 3s-8 3.33-8 7.5zM9.5 18h5v2h-5zm3.5-6.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/Lightbulb.ae3e8db332c3eb7f4b9174ec18302edd.svg";
export { ForwardRef as ReactComponent };